import { translate } from '@/core/localization/translate';
export const {
  title,
  ariaLabelPrevious,
  ariaLabelNext
} = translate({
  "title": "Looking for ways to save energy?",
  "ariaLabelPrevious": "Previous",
  "ariaLabelNext": "Next"
});